<template>
  <TheNotification :is-open="isShowPopUp">
    <div class="p-4">
      <div class="relative mb-4">
        <strong class="block pr-6 text-xl">
          {{ t('title') }}
        </strong>
        <button class="absolute right-0 top-1 h-6 w-6" @click="handleClose">
          <IconClose class="h-full w-full text-black" />
        </button>
      </div>
      <p class="mb-8 text-sm text-gray-600">
        {{ t('description') }}
      </p>
      <ul>
        <li>
          <TheNuxtLink
            :to="`/${locale}/marketplace/products/${route.params.id}/contact-sales`"
            :title="t('button')"
            class="hover:text-blue-400 hover:underline"
            @click="handleClose"
          >
            {{ t('button') }}
          </TheNuxtLink>
        </li>
      </ul>
    </div>
  </TheNotification>
</template>

<script setup lang="ts">
  import _ from 'lodash';

  const route = useRoute();
  const router = useRouter();
  const { t, locale } = useI18n({ useScope: 'local' });

  const isShowPopUp = ref<boolean>(false);

  const handleClose = (): void => {
    isShowPopUp.value = false;
  };

  const checkNoPlanQuery = (): void => {
    if (import.meta.server) {
      return;
    }

    if (route.query.noplan === 'true') {
      isShowPopUp.value = true;
      const query = _.omit(route.query, ['noplan']);
      router.replace({ query });
    }
  };

  watch(() => route.query.noplan, checkNoPlanQuery, { immediate: true });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-jp": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-tw": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-kr": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-americas": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-asia-pacific": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "en-emea": {
    "title": "This plan isn’t available in this region yet",
    "description": "This plan is currently not available in this region and cannot be purchased online at this time. Contact our sales team and we'll be in touch.",
    "button": "Contact sales"
  },
  "ja-jp": {
    "title": "このプランはお住まいの地域では現在ご利用いただけません",
    "description": "このプランは現在この地域ではご利用いただけず、オンラインでのご購入はできません。営業チームまでお問い合わせください。担当者よりご連絡いたします。",
    "button": "営業に問い合わせる"
  },
  "zh-cn": {
    "title": "此方案暂未在此地区开放",
    "description": "此方案目前尚未在本地区开放，暂无法在线购买。请联系我们的销售团队，我们将尽快与您联系。",
    "button": "联系销售"
  },
  "zh-tw": {
    "title": "此方案暫未於此地區開放",
    "description": "此方案目前尚未於本地區開放，暫無法線上購買。請聯繫我們的銷售團隊，我們將盡快與您聯繫。",
    "button": "聯絡銷售"
  }
}
</i18n>
